// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__4oZl2","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3yLD3","obliqueLine":"membershipbadge_obliqueLine__838mb"};